
import { TweenLite } from "gsap";
import { MoneyFormatter } from "../MoneyFormatter";
import { DecodedImageResource, ImageResource } from "../ResourceManager/ImageResource";
import { Resourceful } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../ResourceManager/ResourceManager";
import { CreateElement, Scale } from "../MyHelpers";
import { Settings } from "../Settings";
import { ZIndex } from "../ZIndex";
import { service } from "../services";
import { DenomSelectedCallback } from "./DenomMenu";
import * as PIXI from "pixi.js";
import gsap from "gsap";
import { FixedSizeFitContainer, ResponsiveSizeContainer, ResponsiveView } from "../../singlegame/ResponsiveHelpers";
//gsap.registerPlugin(gsap.plugins.pixi);

//export type DenomSelectedCallback = (denomCents: number) => void;

//type NewType = IWriteOnlyResourceManager;

export class DenomMenuPIXIAPP_Responsive implements Resourceful
{
	protected denomCents:number [] = [];
	//protected view: HTMLElement = null;
	protected path:string = Settings.ResourcesFolder + "multigame/slot/common/resources/DenomMenu/";
	protected resid: ResourceIdentifier = null;

	//private denomButtons:HTMLButtonElement []= [];
	//protected denomMenu:HTMLElement = null;
	//protected denomInfo:HTMLElement = null;
	//protected denomTitle:HTMLElement = null;
	//protected denomContainer:HTMLElement = null;

	protected denomSelectedCalback:DenomSelectedCallback  = null;

	protected isLocked:boolean = false;



	//add base path game
	protected basePathGame:string=null;

	constructor(denomCents: number [], resid: ResourceIdentifier, basePathGame:string)
	{
		this.denomCents = denomCents;
		this.resid = resid.Add("DenomMenu");

		// this.view = CreateElement("div", {
		// 	classes: [this.resid.Scope()],
		// 	style: {
		// 		position: "absolute",
		// 		pointerEvents: "all",
		// 		width: "100%",
		// 		height: "100%",
		// 		top: "0px",
		// 		left: "0px",

		// 		backgroundColor: "rgba(0,0,0,0.5)",
		// 		fontFamily: "NotoSansDisplay-Bold",
		// 		zIndex:ZIndex.DemonContainer.toString(),
		// 	}
		// });

		this.basePathGame=basePathGame;
	}

	public PrepareResources(resourceManager: IWriteOnlyResourceManager)
	{
		//resourceManager.Add(new CSSResource(this.path + "denomMenu.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));

		resourceManager.Add(new DecodedImageResource(this.path + "denom-frame.png", this.resid.ScopedResourceName(["frame","image"])));
		//resourceManager.Add(new ImageResource(this.basePathGame + "resources/denom.png", this.resid.ScopedResourceName(["denom","image"])));

		resourceManager.Add(new DecodedImageResource(this.basePathGame + "resources/denom.png", this.resid.ScopedResourceName(["denom","image"])));
		
	}

	protected denomBackgroundImageTexturePIXI: PIXI.Texture<PIXI.Resource> = null;
	protected frameButtonImageTexturePIXI: PIXI.Texture<PIXI.Resource> = null;
	public ResourcesLoaded(resourceManager: IReadOnlyResourceManager)
	{
		//create texture for denom background 
		let imageDecodeDenomBackground = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["denom","image"])).DecodedImage()
        this.denomBackgroundImageTexturePIXI = PIXI.Texture.from(imageDecodeDenomBackground);


		let frameImageDecodeDenomBackground = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["frame","image"])).DecodedImage()
        this.frameButtonImageTexturePIXI = PIXI.Texture.from(frameImageDecodeDenomBackground);
		
		//this.Hide();

	}

	public DenomSelectedCallback(callback: DenomSelectedCallback): void {
		this.denomSelectedCalback = callback;
	}

	public View(): HTMLElement
	{
		return null;
	}

	public ViewPIXIAPP(): PIXI.Container
	{
		return this.responsiveView;
	}

	// protected visible: boolean = true;
	public Show() {
		// if (this.visible) return;
		// this.visible = true;

		//this.view.style.visibility = "visible";
		//TweenLite.fromTo(this.denomInfo, 0.5, { scale: 0 }, { scale: 1 });
		//missing convert anim to gsap 
		if (this.responsiveView.visible == true) return;
		this.responsiveView.visible = true;
		this.responsiveView.interactiveChildren = true;
		
		this.isLocked = true;
	}

	public Hide()
	{
		// if (!this.visible) return;
		// this.visible = false;

		//TweenLite.set(this.	, {scale:0});
		//missing convert anim to gsap 
		//this.view.style.visibility = "hidden";
		if( this.responsiveView.visible == false ) return;
		this.responsiveView.visible = false;
		this.isLocked = false;
	}

	public IsLocked():boolean
	{
		return this.isLocked;
	}

	public AutoDenom()
	{
		if(this.denomSelectedCalback != null)
		{
			this.denomSelectedCalback(this.denomCents[0]);
		}
	}

	protected responsiveView: ResponsiveView = null;
	protected denomInfoPIXIAPP: PIXI.Container = null;
	protected textureDenomView: PIXI.Sprite = null;


	protected createResponsiveElements() {
        this.responsiveView = new ResponsiveView(window.screen.availWidth, window.screen.availHeight, {color: 0x220000, name: 'responsive-view'});  
		this.responsiveView.name = "denom-responsive-view";

		this.responsiveView.visible = false;

	}
	protected denomMenuResponsiveBackgroundContainer: ResponsiveSizeContainer = null;
	protected denomMenuBackground: FixedSizeFitContainer = null;

	protected denomInfoResponsiveContainer: ResponsiveSizeContainer = null;
	protected denomMenuContainer: FixedSizeFitContainer = null;
	
	
	public CreatePIXIAPP() {
		this.createResponsiveElements();
		// this.responsiveView = new PIXI.Container();
		// this.responsiveView.name = "DenomMenuViewPIXIAPP";
		// this.responsiveView.position.set(0,Settings.ScreenHeight * (Settings.Screens - 1));
		// this.responsiveView.visible = false;
		this.denomMenuResponsiveBackgroundContainer = new ResponsiveSizeContainer(0, 0, 1, 1, NaN, {color: 0x990000, name: 'denom-responsive-background-container'});
        this.responsiveView.addChild(this.denomMenuResponsiveBackgroundContainer);
		
		this.denomInfoResponsiveContainer = new ResponsiveSizeContainer(0, 0.25 , 1, 0.6, NaN, {color: 0x990000, name: 'denom-info-responsive-container'});
        this.responsiveView.addChild(this.denomInfoResponsiveContainer);

        this.denomMenuContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080), {color: 0xbb0000, name: 'denom-menu-container'});
        this.denomInfoResponsiveContainer.addChild(this.denomMenuContainer);

		this.onResize();
		
		this.denomInfoPIXIAPP = new PIXI.Container();				
		this.denomInfoPIXIAPP.position.set((Scale.W(1920) - Scale.W(1550))/2,(Scale.W(1080)-Scale.H(338)/2)/2);		
		// this.denomInfoPIXIAPP.pivot.set(Scale.W(1550)/2 , Scale.Y(550));
		this.denomInfoPIXIAPP.name = "denom-info";		
		// this.responsiveView.addChild(this.denomInfoPIXIAPP);	
		this.denomMenuContainer.addChild(this.denomInfoPIXIAPP);			
		
		let textureDenomInfo = new PIXI.Sprite(this.denomBackgroundImageTexturePIXI);
		textureDenomInfo.width = Scale.W(1550);
		textureDenomInfo.height =  Scale.H(338);
		//textureDenomInfo.tint = "white";
		//textureDenomInfo.alpha = 0.8;
		this.denomInfoPIXIAPP.addChild(textureDenomInfo);

		let elementTextPIXIAPP = new PIXI.Text(service.translator.t.selectDenom, {
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: Scale.fh(90),			
			fontWeight: 'bold',
			fill: ["white"], // gradient
			stroke: 'black',
			strokeThickness:  Scale.fh(8),			
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
        });
		
		elementTextPIXIAPP.anchor.set(0.5,0.5);
		elementTextPIXIAPP.position.set(Scale.W(1550)/2, Scale.H(80));
		service.translator.SetOnLanguageChangedCallback(()=>{
			elementTextPIXIAPP.text = service.translator.t.selectDenom;
		});

		this.denomInfoPIXIAPP.addChild(elementTextPIXIAPP);
		this.CreateDenomButtonsPIXIAPP();
		//return this.viewPIXIAPP;
	}
	
	private CreateDenomButtonsPIXIAPP(): void {
		let buttonContainer = new PIXI.Container();
		buttonContainer.name =  "buttonContainer";		
		this.denomInfoPIXIAPP.addChild(buttonContainer);
		buttonContainer.position.set(this.denomInfoPIXIAPP.width/2, Scale.Y(210));

		this.denomCents.forEach((cents,index) => {
			let buttonDenomPIXIAPP = new PIXI.Container();
			buttonDenomPIXIAPP.name = `buttonDenomPIXIAPP-${cents}`;
			buttonDenomPIXIAPP.interactive = true;
			buttonDenomPIXIAPP.addListener("pointerdown",()=>{
				if(this.denomSelectedCalback != null)
					{
						this.denomSelectedCalback(cents);
					}
			})
			//buttonDenomPIXIAPP.height = Scale.H(40);			
			buttonContainer.addChild(buttonDenomPIXIAPP);
			let textureButtonPIXI = new PIXI.Sprite(PIXI.Texture.WHITE);			
			textureButtonPIXI.height = Scale.H(90);		
			textureButtonPIXI.tint = "black";
			//textureButtonPIXI.alpha = 0.5;
			buttonDenomPIXIAPP.addChild(textureButtonPIXI);

			let unlockFeatureFrameSprite = new PIXI.NineSlicePlane(this.frameButtonImageTexturePIXI,1,1,1,1);            
            unlockFeatureFrameSprite.name = "unlockFeatureFrameSprite";
           // unlockFeatureFrameSprite.width = this.windowRectangle.width;
            unlockFeatureFrameSprite.height = Scale.H(90);
            buttonDenomPIXIAPP.addChild(unlockFeatureFrameSprite);

			// if (this.denomCents.length <= 4) {				
			// 	textureButtonPIXI.width = Scale.W(1550) * 0.16;
			// 	unlockFeatureFrameSprite.width = Scale.W(1550) * 0.16;
			// }
			// else if (this.denomCents.length >= 5) {
			// 	textureButtonPIXI.width = Scale.W(1300) * 0.16;
			// 	unlockFeatureFrameSprite.width = Scale.W(1300) * 0.16;
			// }
			let minWidth = Scale.W(1300)*0.16;
			let maxWidth = Scale.W(1550)*0.16;

			// let calculatedBtnWidth = this.denomInfoPIXIAPP.width*0.7/this.denomCents.length;

			let calculatedBtnWidth = Math.max(minWidth, Math.min(this.denomInfoPIXIAPP.width*0.7/this.denomCents.length, maxWidth));
						
			textureButtonPIXI.width = calculatedBtnWidth;//Scale.W(1300) * 0.16;
			unlockFeatureFrameSprite.width = calculatedBtnWidth;//Scale.W(1300) * 0.16;

			buttonDenomPIXIAPP.position.set(unlockFeatureFrameSprite.width * index,0);

			let textDenomCents = new PIXI.Text(service.moneyFormatter.FormatCurrency(cents),{
				fontFamily: 'NotoSansDisplay-Bold',			
				fontSize: Scale.fh(50),			
				fontWeight: 'bold',
				fill: ["white"], // gradient
				stroke: 'black',
				strokeThickness:  Scale.fh(8),			
				//wordWrap: true,			
				lineJoin: 'round',
				//textBaseline : "middle",			
			});

			textDenomCents.anchor.set(0.5,0.5);
			textDenomCents.position.set(buttonDenomPIXIAPP.width/2,buttonDenomPIXIAPP.height/2);
			buttonDenomPIXIAPP.addChild(textDenomCents);
		});
		
		buttonContainer.pivot.set(buttonContainer.width/2,buttonContainer.height/2);
	}
	protected createBackgroundDenomView() {
		this.denomMenuBackground?.destroy({children: true});

		this.denomMenuBackground = new FixedSizeFitContainer(window.innerWidth, window.innerHeight, {color: 0xbb0000, name: 'reels-container'});
        this.denomMenuResponsiveBackgroundContainer?.addChild(this.denomMenuBackground);

		this.textureDenomView = new PIXI.Sprite(PIXI.Texture.WHITE);
		this.textureDenomView.width = window.innerWidth;
		this.textureDenomView.height = window.innerHeight;
		this.textureDenomView.tint = "black";
		this.textureDenomView.alpha = 0.8;
		this.denomMenuBackground.addChild(this.textureDenomView);		
	}

	public onResize(): void {
		this.createBackgroundDenomView();
		this.responsiveView.setAvailableSize(window.innerWidth, window.innerHeight);
	}
}